/**
 * 비로그인(accessToken 없음) 상태에서도 접근을 허용하는 경로.
 * 라우터 전역 가드(`router/index.ts` beforeEach) 가 `isPublicPath(to.path)` 로 판정한다.
 *
 * - PUBLIC_EXACT_PATHS: 경로 문자열이 정확히 일치해야 하는 기존 예외 목록 (로그인·가입·약관)
 * - PUBLIC_PATH_PREFIXES: 하위 경로까지 통째로 공개인 섹션 (`/guide`, `/guide/news` …).
 *   세그먼트 경계에서만 맞춘다 — `/guidebook` 은 공개가 아니다.
 */
export const PUBLIC_EXACT_PATHS: readonly string[] = [
  '/login',
  '/register',
  '/register-select',
  '/register-helpi',
  '/policy/helpi-service',
  '/policy/helpi-community',
  '/policy',
  '/policy/personal',
  '/policy/collectUsePersonalRequired',
  '/policy/collectUsePersonalOptional',
  '/policy/collectUsePersonalRequiredHelpi',
]

/** 하이버 셀러허브 공개 가이드 — 로그인 없이 보는 안내 문서 */
export const PUBLIC_PATH_PREFIXES: readonly string[] = ['/guide']

const matchesPrefix = (path: string, prefix: string) => path === prefix || path.startsWith(`${prefix}/`)

/** 공개 가이드 섹션(`/guide`, `/guide/…`) 인지 — 세션 타임아웃 판정 예외 등에 사용 */
export const isGuidePath = (path: string): boolean => matchesPrefix(path, '/guide')

export const isPublicPath = (path: string): boolean => {
  if (!path) return false
  if (PUBLIC_EXACT_PATHS.includes(path)) return true
  return PUBLIC_PATH_PREFIXES.some((prefix) => matchesPrefix(path, prefix))
}
